import { z } from "zod";

// Shipment Management
export const shipmentManagementProgressBucketSchema = z.object({
	inGoodStanding: z.number(),
	outstandingIssues: z.number(),
});

export const shipmentManagementSchema = z.object({
	exceptions: z.object({
		immediateActionCount: z.number(),
		needsAcknowledgedCount: z.number(),
	}),
	statuses: z.object({
		notDispatchedDatedToday: z.number(),
		pastPickupsNotYetTracking: z.number(),
	}),
	shipmentProgress: z.object({
		todaysPickups: shipmentManagementProgressBucketSchema,
		inTransit: shipmentManagementProgressBucketSchema,
		todaysDeliveries: shipmentManagementProgressBucketSchema,
	}),
});

export type ShipmentManagement = z.infer<typeof shipmentManagementSchema>;

// Accounts Receivable
export const accountsReceivableSchema = z.object({
	billingExceptions: z.number(),
	paperworkMissing: z.number().nullable(),
	invoicesApproaching75Days: z.number().nullable(),
});

export type AccountsReceivable = z.infer<typeof accountsReceivableSchema>;

// Claims
export const claimsSchema = z.object({
	validation: z.number(),
	activeClaims: z.number(),
	resolvedClaims: z.number(),
});

export type Claims = z.infer<typeof claimsSchema>;

// Sales Performance
export const salesPerformanceRowSchema = z.object({
	customerId: z.number(),
	customerName: z.string(),
	shipments: z.number(),
	quotes: z.number().nullable(),
	quoteRatio: z.number().nullable(),
	brokerageRevenue: z.number(),
});

export const salesPerformanceSchema = z.object({
	rows: z.array(salesPerformanceRowSchema),
	totalBrokerageRevenue: z.number(),
});

export type SalesPerformanceRow = z.infer<typeof salesPerformanceRowSchema>;
export type SalesPerformance = z.infer<typeof salesPerformanceSchema>;

// Quote Summary (LTL Quoting API) - sources the Quotes / SQ Ratio metrics for
// the Sales Performance card.
export const quoteSummaryRowSchema = z.object({
	customerId: z.number(),
	customerName: z.string().nullable(),
	quotes: z.number(),
	quoteRatio: z.number(),
});

export const quoteSummarySchema = z.array(quoteSummaryRowSchema);

export type QuoteSummaryRow = z.infer<typeof quoteSummaryRowSchema>;
export type QuoteSummary = z.infer<typeof quoteSummarySchema>;

// Carriers
export const carrierRowSchema = z.object({
	carrierId: z.number(),
	carrierName: z.string(),
	ltlCount: z.number(),
	avgHandlingUnits: z.number(),
	avgWeight: z.number(),
	avgMiles: z.number(),
	avgTransitDays: z.number(),
});

export const carriersSchema = z.object({
	carriers: z.array(carrierRowSchema),
});

export type CarrierRow = z.infer<typeof carrierRowSchema>;
export type Carriers = z.infer<typeof carriersSchema>;

// Account Reps
export const accountRepSchema = z.object({
	arId: z.number(),
	displayName: z.string(),
});

export const accountRepsSchema = z.object({
	accountReps: z.array(accountRepSchema),
});

export type AccountRep = z.infer<typeof accountRepSchema>;
export type AccountReps = z.infer<typeof accountRepsSchema>;
